module.exports = __webpack_public_path__ + "img/hr-water-green1.96573152.png";